import React, { useState } from "react";
import { TextField } from "@mui/material";
import {currencySymbol} from "../../../../config/values";

const CurrencyTextField = ({ value, onChange, label, ...props }) => {
    const [displayValue, setDisplayValue] = useState(
        value ? value.toLocaleString("en-US") : ""
    );

    const handleInputChange = (e) => {
        const rawValue = e.target.value.replace(/,/g, ""); // Remove commas
        if (/^\d*$/.test(rawValue)) { // Only allow numbers
            const intValue = parseInt(rawValue, 10) || 0; // Convert to integer
            setDisplayValue(intValue.toLocaleString("en-US")); // Format with thousand separator
            onChange(intValue); // Return raw integer value
        }
    };

    return (
        <TextField
            {...props}
            label={label}
            value={displayValue}
            onChange={handleInputChange}
            slotProps={{
                input:{
                    endAdornment: currencySymbol,
                    inputMode: "numeric",
                    pattern: "\\d*", // Only allow digits
                }
            }}
        />
    );
};

export default CurrencyTextField;
